import { warehouse } from "constants/endpoints";
import http from "utils/http";

const getWarehouses = () => {
  const GET_CLIENTS_ENDPOINT = warehouse.get();
  const { REACT_APP_API_BASE_URL: API_BASE_URL } = process.env;
  return http.get(`${API_BASE_URL}${GET_CLIENTS_ENDPOINT}`);
};

export default getWarehouses;
